<div class="card card-micro text-center" (click)="clicked()">
    <div class="card-body">
        <div class="d-flex justify-content-center align-items-center">
            <h2 class="font-weight-bolder">{{ticker}}</h2>
            <div class="avatar p-50 mb-1 mx-1" [ngClass]="{'bg-light-success': data?.percentageChange > 0, 'bg-light-danger': data?.percentageChange < 0, 'bg-light-secondary': data?.percentageChange == 0}">
                <div class="avatar-content">
                    <ng-container *ngTemplateOutlet="icon; context: { percentage: data?.percentageChange}"></ng-container>
                </div>
            </div>
            <h2 class="font-weight-bolder text-secondary" [ngClass]="{'text-success': data?.percentageChange > 0, 'text-danger': data?.percentageChange < 0, 'text-secondary': data?.percentageChange == 0}">{{data?.percentageChange}}%</h2>    
        </div>
        <p class="card-text info">{{info}}</p>
    </div>
</div>

<ng-template #icon let-percentage="percentage">
    <i *ngIf="percentage > 0" data-feather="trending-up" class="avatar-icon font-medium-3"></i>
    <i *ngIf="percentage < 0" data-feather="trending-down" class="avatar-icon font-medium-3"></i>
    <i *ngIf="percentage == 0" data-feather="minus-square" class="avatar-icon font-medium-3"></i>
</ng-template>